// removed by extract-text-webpack-plugin
module.exports = {"button":"_2pVjmkWasNDSDi6HaUXfBN","subtitle":"_7C31-zo5ADLrM1NG-GLap","success":"_3hblGyE6G8CTQW2zT702T9"};


//////////////////
// WEBPACK FOOTER
// ./src/Pages/SignUpPage/SignUpPage.css
// module id = 669
// module chunks = 3